import React from 'react';
import { View } from '@applane/react-core-components';
import HomeStyle from './HomeStyle';

const CardBox = ({ head, content }) => (
  <View style={HomeStyle.hiwCardContainer}>
    <View style={HomeStyle.hiwCardContent}>
      <View style={HomeStyle.hiwCardHeader}>{head}</View>
      <View style={HomeStyle.hiwCardDiscription}>
        {content[0]}
        <br />
        {content[1]}
      </View>
    </View>
  </View>
);
export default CardBox;
